import { get } from "../GenericServices";

const Currency = {
  currencies: (queryString) => {
    return get(`currency?${queryString}`);
  },
};

export default Currency;
